
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M256 0C114.609 0 0 114.609 0 256c0 141.391 114.609 256 256 256 141.391 0 256-114.609 256-256C512 114.609 397.391 0 256 0zm0 472c-119.297 0-216-96.703-216-216S136.703 40 256 40s216 96.703 216 216-96.703 216-216 216z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M267.922 351.734V384h-25.719v-30.406c-19.516-.609-39.047-6.25-50.203-13.469l8.375-29.766c12.406 7.531 29.438 13.781 48.344 13.781 19.812 0 33.141-9.703 33.141-24.438 0-14.392-10.827-23.156-34.077-31.642-32.219-11.905-53.609-27.25-53.609-56.094 0-26.938 18.609-47.938 49.891-53.562V128h25.406v28.828c19.517.625 32.859 5.641 42.781 10.656l-8.375 28.828c-7.438-3.75-21.078-10.969-42.142-10.969-21.702 0-29.452 11.281-29.452 21.938 0 12.844 11.156 20.359 37.812 30.719C304.797 251.156 320 268.062 320 296.281c0 26.641-18.297 49.813-52.078 55.453z"}})])
          )
        }
      }
    